// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1mZDM","type":"styles_type__302Vg","choices":"styles_choices__14fEl"};